<template>
  <div class="container mt-4">
    <h2 class="mb-4 text-center">
      <font-awesome-icon icon="box-open" class="me-2" />
      Nuevo Ítem de Inventario
    </h2>
    <form @submit.prevent="crearItemInventario">
      <div class="row g-3">
        <!-- Nombre del ítem -->
        <div class="col-md-6">
          <label for="nombre" class="form-label">Nombre del Ítem</label>
          <input
            id="nombre"
            v-model="nuevoItem.nombre"
            type="text"
            class="form-control form-control-sm"
            required
          />
        </div>

        <!-- Categoría con buscador -->
        <div class="col-md-6">
          <label for="categoria" class="form-label">Categoría</label>
          <input
            v-model="searchCategoria"
            type="text"
            class="form-control form-control-sm mb-1"
            placeholder="Buscar categoría..."
          />
          <select
            id="categoria"
            v-model="nuevoItem.categoria"
            class="form-select form-select-sm"
            required
          >
            <option value="" disabled>Seleccionar categoría</option>
            <option
              v-for="cat in filteredCategories"
              :key="cat.id"
              :value="cat.id"
            >
             {{ cat.descripcion }}
            </option>
          </select>
        </div>

        <!-- Cantidad -->
        <div class="col-md-6">
          <label for="cantidad" class="form-label">Cantidad</label>
          <input
            id="cantidad"
            v-model.number="nuevoItem.cantidad"
            type="number"
            class="form-control form-control-sm"
            min="0"
            required
          />
        </div>

        <!-- Unidad de medida -->
        <div class="col-md-6">
          <label for="unidad" class="form-label">Unidad de Medida</label>
          <select
            id="unidad"
            v-model="nuevoItem.unidad_de_medida"
            class="form-select form-select-sm"
            required
          >
            <option value="" disabled>Seleccionar unidad</option>
            <option
              v-for="u in unidadesMedida"
              :key="u"
              :value="u"
            >
              {{ u }}
            </option>
          </select>
        </div>

        <!-- Nivel mínimo -->
        <div class="col-md-6">
          <label for="nivel_minimo" class="form-label">Nivel Mínimo</label>
          <input
            id="nivel_minimo"
            v-model.number="nuevoItem.nivel_minimo"
            type="number"
            class="form-control form-control-sm"
            min="0"
          />
        </div>

        <!-- Costo unitario -->
        <div class="col-md-6">
          <label for="costo_unitario" class="form-label">Costo Unitario $</label>
          <input
            id="costo_unitario"
            v-model.number="nuevoItem.costo_unitario"
            type="number"
            step="0.01"
            class="form-control form-control-sm"
            min="0"
          />
        </div>
      </div>

      <button type="submit" class="btn btn-primary mt-4 w-100">
        Crear Ítem
      </button>
      <button type="button" class="btn btn-secondary mt-4 w-100" @click="$emit('cancelarCreacionItem')">
        Cancelar
      </button>
    </form>
  </div>
</template>

<script>
import axios from '@/axios';

export default {
  props: {
    proveedor_id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      nuevoItem: {
        nombre: '',
        categoria: '',
        cantidad: null,
        unidad_de_medida: '',
        nivel_minimo: null,
        costo_unitario: null,
        proveedor_id: this.proveedor_id,
      },
      categoriasExistentes: [],
      unidadesMedida: [],
      searchCategoria: '',
      clubActual: null,
    };
  },
  created() {
    this.clubActual = this.$store.getters.getClubActual;
    this.fetchCategorias();
    this.fetchUnidadesMedida();
  },
  computed: {
    filteredCategories() {
      const term = this.searchCategoria.trim().toLowerCase();
      if (!term) return this.categoriasExistentes;
      return this.categoriasExistentes.filter(cat =>
        cat.descripcion.toLowerCase().includes(term)
      );
    },
  },
  methods: {
    async fetchCategorias() {
      try {
        const { data } = await axios.get('/api/constantes/inventario_categorias');
        this.categoriasExistentes = data;
      } catch (err) {
        console.error('Error al obtener categorías:', err);
      }
    },
    async fetchUnidadesMedida() {
      try {
        const { data } = await axios.get('/api/constantes/unidades-medida');
        this.unidadesMedida = data;
      } catch (err) {
        console.error('Error al obtener unidades de medida:', err);
      }
    },
    async crearItemInventario() {
      try {
        const payload = {
          form: {
            ...this.nuevoItem,
            costo_unitario_usd: this.nuevoItem.costo_unitario,
          },
          club_id: this.clubActual.id
        };
        const respuesta=await axios.post('/api/inventario', payload);
        alert('Ítem de inventario creado exitosamente');

        this.$emit('itemCreado', respuesta.data);
      } catch (err) {
        console.error('Error al crear ítem:', err);
        alert('Hubo un error al crear el ítem de inventario.');
      }
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 800px;
}
h2 {
  font-weight: bold;
}
.form-label {
  font-size: 0.9rem;
}
.btn {
  font-size: 1rem;
}
</style>
